import { useSelector, useDispatch } from 'react-redux'
import Marker from '../../map/Marker.js'

export default function StoryMarker ({ slice, iconUrl, tooltipDirection }) {
  const { actions, selectors } = slice
  const dispatch = useDispatch()
  const marker = useSelector(selectors.selectMarker)

  return (marker &&
    <Marker
      popupText={marker.text}
      location={marker.location}
      goToMarker={() => dispatch(actions.goToMarker())}
      iconUrl={iconUrl}
      tooltipDirection={tooltipDirection}
    />)
}
